import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { User, AlertCircle, Mail, Phone, Building2, Award, Star, Calendar, Eye, CheckCircle, XCircle } from 'lucide-react';
import { CATEGORIES_EXPERTISE, calculateQualityScore } from './expertsValidationShared';

export const ExpertCard = ({ expert, onDetail, onValidate, onReject }) => {
  const qualityScore = calculateQualityScore(expert);
  return (
                  <Card key={expert.id} className="border-2 border-purple-200 hover:border-purple-400 transition-all">
                    <CardContent className="pt-6">
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <User className="h-5 w-5 text-purple-600" />
                            <h3 className="font-bold text-lg text-gray-900">
                              {expert.prenom} {expert.nom}
                            </h3>
                          </div>
                          <div className="flex flex-wrap gap-2 mb-2">
                            <Badge className="bg-orange-600 text-white hover:bg-orange-700 font-semibold">
                              <AlertCircle className="h-3 w-3 mr-1" />
                              En attente
                            </Badge>
                            {expert.categories_expertise?.map(cat => {
                              const catInfo = CATEGORIES_EXPERTISE.find(c => c.value === cat);
                              return catInfo ? (
                                <Badge key={cat} className={`${catInfo.color} text-white`}>
                                  {catInfo.icon} {catInfo.label}
                                </Badge>
                              ) : null;
                            })}
                          </div>
                        </div>

                        <div className="text-center">
                          <div className={`text-2xl font-bold ${
                            qualityScore >= 80 ? 'text-green-600' :
                            qualityScore >= 50 ? 'text-orange-600' :
                            'text-red-600'
                          }`}>
                            {qualityScore}%
                          </div>
                          <p className="text-xs text-slate-500">Qualité</p>
                        </div>
                      </div>

                      <div className="space-y-2 mb-4 bg-slate-50 rounded-lg p-3">
                        <div className="flex items-center gap-2 text-sm">
                          <Mail className="h-4 w-4 text-gray-500" />
                          <span className="text-gray-600">{expert.email}</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <Phone className="h-4 w-4 text-gray-500" />
                          <span className="text-gray-600">{expert.telephone}</span>
                        </div>
                        {expert.raison_sociale && (
                          <div className="flex items-center gap-2 text-sm">
                            <Building2 className="h-4 w-4 text-gray-500" />
                            <span className="text-gray-600">{expert.raison_sociale}</span>
                          </div>
                        )}
                      </div>

                      <div className="space-y-2 mb-3">
                        {expert.numero_agrement && (
                          <div className="bg-blue-50 rounded-lg p-3">
                            <div className="flex items-center gap-2 text-sm">
                              <Award className="h-4 w-4 text-blue-600" />
                              <span className="font-medium">N° Agrément: </span>
                              <span className="text-gray-600">{expert.numero_agrement}</span>
                            </div>
                          </div>
                        )}
                        {expert.ref_expert && (
                          <div className="bg-purple-50 rounded-lg p-3">
                            <div className="flex items-center gap-2 text-sm">
                              <Star className="h-4 w-4 text-purple-600" />
                              <span className="font-medium font-mono text-purple-700">
                                Réf. Expert: {expert.ref_expert}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>

                      {expert.specialites?.length > 0 && (
                        <div className="mb-3">
                          <p className="text-xs text-slate-500 mb-1">Spécialités</p>
                          <div className="flex flex-wrap gap-1">
                            {expert.specialites.map((spec, idx) => (
                              <Badge key={idx} className="bg-blue-600 text-white text-xs font-semibold">
                                {spec}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="text-xs text-gray-500 mb-3">
                        <Calendar className="h-3 w-3 inline mr-1" />
                        Inscrit le {new Date(expert.date_inscription).toLocaleDateString('fr-FR')}
                      </div>

                      <div className="flex gap-2">
                        <Button
                          onClick={() => onDetail(expert)}
                          variant="outline"
                          className="flex-1"
                          size="sm"
                        >
                          <Eye className="h-4 w-4 mr-2" />
                          Détails
                        </Button>
                        <Button
                          onClick={() => onValidate(expert)}
                          className="flex-1 bg-green-600 hover:bg-green-700"
                          size="sm"
                        >
                          <CheckCircle className="h-4 w-4 mr-2" />
                          Valider
                        </Button>
                        <Button
                          onClick={() => onReject(expert)}
                          variant="outline"
                          className="flex-1 border-red-600 text-red-600 hover:bg-red-50"
                          size="sm"
                        >
                          <XCircle className="h-4 w-4 mr-2" />
                          Rejeter
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
  );
};
